import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  errors = {
        "generic": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde",
        "exist": {
        "errors": [
            {
                "code": "EXISTS-IAM001",
                "description": "El usuario se encuentra registrado en la plataforma de Midatacredito pero no en IAM.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-IAM002",
                "description": "Se presenta una novedad durante la consulta del correo electrónico en IAM",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-IAM003",
                "description": "Se presenta una novedad o falla durante el proceso de eliminar el correo electrónico del usuario en IAM.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-ECS001",
                "description": "El usuario no se encuentra registrado en la plataforma de MIDC ni IAM.",
                "message": ""
            },
            {
                "code": "EXISTS-ECS002",
                "description": "El captcha enviado es inválido o el campo se encuentra vació.",
                "message": "Error validando el Captcha. Por favor vuelve a intentarlo."
            },
            {
                "code": "EXISTS-ECS003",
                "description": "Se presenta novedad o falla durante el proceso de consulta en la fuente de información customers.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-ECS004",
                "description": "Se presenta novedad o falla durante el proceso de consulta en la fuente de información tmpCustomers.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-ECS005",
                "description": "Se presenta una novedad o falla durante el proceso de validación de datos por ingresar caracteres especiales o inválidos según el tipo de campo.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-ECS006",
                "description": "Se presenta una novedad o falla no identificada asociada a un comportamiento anormal durante la validación de usuario existSente.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "EXISTS-ECS007",
                "description": "Se presenta novedad o falla durante el proceso de consulta en la fuente de información en Redis.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            }
        ]
      },
      "register": {
        "errors": [
            {
                "code": "REGISTER-IAM014",
                "description": "Correo electrónico o mobile invalido para enviar codigoOTP",
                "message": "El correo que ingresaste es invalido, por favor valídalo para continuar."
            },
            {
                "code": "REGISTER-IAM030",
                "description": "Usuario se encuentra registrado en la plataforma de autenticación pero no tiene contraseña asignada",
                "message": "El correo que ingresaste, ya se encuentra registrado en nuestro sistema, por favor valídalo para continuar."
            },
            {
                "code": "REGISTER-IAM002",
                "description": "Correo electrónico ingresado para registro ya se encuentra en uso con contraseña registrada.",
                "message": "El correo que ingresaste, ya se encuentra registrado en nuestro sistema, por favor valídalo para continuar."
            },
            {
                "code": "REGISTER-IAM999",
                "description": "El usuario o correo ingresado ya se encuentra registrado en la plataforma de IAM.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "REGISTER-ECS001",
                "description": "Novedad guardando información del usuario en temporal customers",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "REGISTER-ECS002",
                "description": "Captcha inválido",
                "message": "Error validando el Captcha."
            },
            {
                "code": "REGISTER-ECS003",
                "description": "Novedad presentada durante la validación de los datos ingresados",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "REGISTER-ECS004",
                "description": "Novedad no identificada presentada durante la validación de usuario existente",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "REGISTER-ECS005",
                "description": "Se presenta una novedad al momento de guardar en tmpCustomer por correo electrónico duplicado.",
                "message": "El correo que ingresaste, ya se encuentra registrado en nuestro sistema, por favor valídalo para continuar."
            },
            {
                "code": "REGISTER-ECS006",
                "description": "Se presenta una novedad al momento de mapear los datos obtenidos de customers",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "REGISTER-ECS007",
                "description": "No se encontró el customers en la base de datos de ECS.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            }
        ]
      },
      "addPassword": {
        "errors": [
            {
                "code": "ADDPASS-IAM006",
                "description": "",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-IAM008",
                "description": "Código de validación o nombre de usuario inválido.",
                "message": "El código que ingresaste no es valido. Por favor verificalo."
            },
            {
                "code": "ADDPASS-IAM017",
                "description": "Correo electrónico ingresado para registro ya se encuentra en uso con contraseña registrada.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-IAM017",
                "description": "Novedad guardando información del usuario en temporal customers",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-ECS002",
                "description": "Se presenta novedad o falla durante el proceso de consulta en la fuente de información tmpCustomers.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-ECS003",
                "description": "Se presenta novedad o falla durante el proceso de consulta en la fuente de información customers.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-ECS004",
                "description": " Se presenta una novedad o falla no identificada asociada a un comportamiento anormal durante la creación de la contraseña.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            },
            {
                "code": "ADDPASS-ECS005",
                "description": "Se presenta una novedad o falla durante el proceso de guardando de información del usuario en customers (CUSTOMES).",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde"
            }
        ]
      },
      "login":{
        "errors":[
            {
                "code": "LOGIN-IAM008",
                "description": "Novedad durante validación del código o nombre de usuario en IAM",
                "message": "Tus datos de inicio de sesión no son correctos. Por favor valídalos para continuar."
            },
            {
                "code": "LOGIN-IAM012",
                "description": "Novedad durante validación del código o nombre de usuario en IAM",
                "message": "Tus datos de inicio de sesión no son correctos. Por favor valídalos para continuar."
            },
            {
                "code": "LOGIN-IAM016",
                "description": "Novedad durante validación de la contraseña en IAM",
                "message": ""
            },
            {
                "code": "LOGIN-IAM062",
                "description": "Novedad durante validación de la contraseña en IAM, se bloquea usuario temporalmente",
                "message": "Tu usuario se encuentra bloqueado por exceder el número de intentos erroneos. Por favor inténtalo nuevamente en 30 minutos."
            },
            {
                "code": "LOGIN-IAM999",
                "description": "Novedad durante validación de credenciales en IAM.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor inténtalo más tarde."
            },
            {
                "code": "LOGIN-ECS001",
                "description": "Novedad presentada durante validación de id de la aplicación.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor inténtalo más tarde."
            },
            {
                "code": "LOGIN-ECS002",
                "description": "Novedad presentada durante la consulta del usuario.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor inténtalo más tarde."
            },
            {
                "code": "LOGIN-ECS003",
                "description": "Novedad presentada durante la consulta del usuario. (TIME OUT EN CODIGO OTP)",
                "message": ""
            },
            {
                "code": "LOGIN-ECS004",
                "description": "No se encontraron datos de usuario ingresado.",
                "message": "En este momento nuestro sistema no puede responder a tu solicitud, por favor inténtalo más tarde."
            }
        ]
      }
    };

    public errorMessage:string[]= ["En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde","000"]; 
    public errorProcess={
      exist: false,
      addPass:false,
      firstAuth:false
    }

  constructor() { }

  setErrorMessage(process:string,code:string){
    let error;
    this.errorMessage[0]= this.errors.generic; 
    this.errorMessage[1] = code;
    switch (process) {
        case 'EXIST':
            error = this.errors.exist.errors.find(data => data.code === code);
            error?this.errorMessage[0]= error.message:this.errorMessage[0]=this.errors.generic; 
            break;
        case 'REGISTER':
            error = this.errors.register.errors.find(data => data.code === code);
            error?this.errorMessage[0]= error.message:this.errorMessage[0]=this.errors.generic; 
            break;

        case 'ADD_PASS':
            error = this.errors.addPassword.errors.find(data => data.code === code);
            error?this.errorMessage[0]= error.message:this.errorMessage[0]=this.errors.generic; 
            break;
        case 'LOGIN':
            error = this.errors.login.errors.find(data => data.code === code);
            error?this.errorMessage[0]= error.message:this.errorMessage[0]=this.errors.generic; 
            break;
        
        default:
            this.errorMessage[0]= this.errors.generic; 
            this.errorMessage[1] = code;
    }
  }
}
